import { encryptStorage } from 'src/Util'
import { addCrwalAPI, crawlAPI } from "../api";

export const LIST_SCAN_REQUEST = 'LIST_SCAN_REQUEST';
export const LIST_SCAN_SUCCESS = 'LIST_SCAN_SUCCESS';
export const LIST_SCAN_FAILED = 'LIST_SCAN_FAILED';

export const CRAWL_ADD = 'CRAWL_ADD';
export const CRAWL_ADD_SUCCESS = 'CRAWL_ADD_SUCCESS';
export const CRAWL_ADD_FAILED = 'CRAWL_ADD_FAILED';

export const listScanRequest = () => {
    return{
        type:LIST_SCAN_REQUEST
    }
}

export const listScanSuccess = scans => {
    return{
        type: LIST_SCAN_SUCCESS,
        payload:scans
    }
}

export const listScansFailure = error => {
    return{
        type:LIST_SCAN_FAILED,
        payload:error
    }
}

export const listAllScans = () => {
    const userDetail = (encryptStorage.getItem('session-user'))
    var user_id = userDetail.user_id;
    return (dispatch) => {
        dispatch(listScanRequest)
        crawlAPI.get('/accessibility-docmd-service/scan/user?user_id='+user_id,{
            headers: {'Content-Type': 'application/json'}
        })
        .then(response=>{
            const data = {
                scansList : response.data
            }
            dispatch(listScanSuccess(data))
        })
        .catch(error=>{
            const errorMsg = error.message
            dispatch(listScansFailure(errorMsg))
        })
    }
}

export const startCrawlAddition = () => {
    return {
        type:CRAWL_ADD
    }
}

export const crawlAdditionSuccess = (res) => {
    return {
        type: CRAWL_ADD_SUCCESS,
        payload: res.data
    }
}

export const crawlAdditionFailure = (error) => {
    return {
        type: CRAWL_ADD_FAILED,
        payload:error
    }
}

export const addNewCrawl = (crawlDetail) => {
    const userDetail = (encryptStorage.getItem('session-user'))
    var user_id = userDetail.user_id;
    console.log('new user id', user_id)
    return (dispatch) => {
        dispatch(startCrawlAddition())
        addCrwalAPI.post('/accessibility-docmd-service/crawl/user?user_id='+user_id, crawlDetail,
            {
                headers: {
                    'Content-Type': 'application/json',
                    
                },
            }
        ).then((res)=>{

             console.log("crawl addition detail", res)
             dispatch(crawlAdditionSuccess(res))
        })
        .catch((error)=>{
            dispatch(crawlAdditionFailure(error))
        })
    }
}